// 1.vue一家：
import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App.vue';
// 2.UI框架 iview：
import 'iview/dist/styles/iview.css';
import iView from 'iview';
// 3.其他全局挂载：
import utils from '@/utils';
import api from '@/api';
import globalComponents from '@/components/global';
import cssVariable from '@/styles/base/variable-js';
// 4.全局样式，在其他框架的全局样式之后引用：
import '@/styles/global/index.scss';
import 'animate.css';
// 5.挂载swiper 感觉vue-swiper有点画蛇添足
/*import vueSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import 'swiper/swiper.scss';
import { Swiper as SwiperClass, Pagination, Autoplay, Navigation } from 'swiper/core';
SwiperClass.use([Pagination, Autoplay, Navigation]);
Vue.use(vueSwiper)*/
// iview 全局配置：
Vue.use(iView);
// 其他全局挂载、Vue.use：
Vue.use(utils);
Vue.use(api);
Vue.use(globalComponents);
Vue.use(cssVariable);
utils.setRem(); // rem设置
// 5.调试选项设置：
Vue.config.productionTip = false;
// 6.创建vue实例：
new Vue({
  computed : {
    nodeEnv(){
      return process.env.NODE_ENV;
    },
  },
  router,
  store,
  comments : true,
  render   : h => h(App),
}).$mount('#app');
